const {
  VITE_GRAPHQL_URL,
  VITE_SERVICE_URL,
  VITE_RESOURCES_BUCKET,
} = import.meta.env;

export function getGraphqlUrl(): string {
  if (!VITE_GRAPHQL_URL)
    throw Error("Environment variable VITE_GRAPHQL_URL is not configured");

  return VITE_GRAPHQL_URL;
}

export function getServiceUrl(): string {
  if (!VITE_SERVICE_URL)
    throw Error("Environment variable VITE_SERVICE_URL is not configured");

  return VITE_SERVICE_URL;
}

export function getResourcesBucket(): string {
  if (!VITE_RESOURCES_BUCKET)
    throw Error("Environment variable VITE_RESOURCES_BUCKET is not configured");

  return VITE_RESOURCES_BUCKET;
}
